export const DURATION_UNIT_FALLBACK = "days";

export const durationUnitMap = {
  minutes: "minute",
  hours: "hour",
  days: "day",
  weeks: "week",
  months: "month",
  years: "year",
};

export const parseCombinedDuration = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return { value: "", unit: "" };
  const match = raw.match(/^(\d+)\s+([a-zA-Z]+)$/);
  if (!match) return { value: "", unit: "" };
  return {
    value: match[1],
    unit: String(match[2]).toLowerCase(),
  };
};

export const buildCombinedDuration = (value, unit) => {
  if (value === null || value === undefined || value === "") return "";
  const cleanValue = String(value).replace(/\D/g, "");
  const cleanUnit = String(unit || "").trim().toLowerCase();
  if (!cleanValue || !cleanUnit) return "";
  return `${cleanValue} ${cleanUnit}`;
};

export const normalizeLegacyDuration = (
  combinedValue,
  legacyValue,
  legacyUnit,
  fallbackUnit = DURATION_UNIT_FALLBACK
) => {
  const combined = String(combinedValue || "").trim();
  if (combined && parseCombinedDuration(combined).value) return combined;
  return buildCombinedDuration(
    String(legacyValue || "").replace(/\D/g, ""),
    legacyUnit || fallbackUnit
  );
};

export const formatDurationUnitForDisplay = (unit) => {
  const normalized = String(unit || "").trim().toLowerCase();
  return normalized ? normalized.toUpperCase() : "";
};

export const formatCombinedDurationForDisplay = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const parsed = parseCombinedDuration(raw);
  if (!parsed.value) return raw;
  return `${parsed.value} ${formatDurationUnitForDisplay(parsed.unit)}`;
};

export const getDurationDropdownOptions = (numericInput, durationType = []) => {
  const numberPart = String(numericInput || "").replace(/\D/g, "");
  if (!numberPart) return [];
  return durationType.map(
    (type) => `${numberPart} ${formatDurationUnitForDisplay(type.value)}`
  );
};

const TIME_UNIT_PATTERN =
  /\b(minute|minutes|hour|hours|day|days|week|weeks|month|months|year|years)\b/gi;

/** Uppercase duration units (and "ago") for PDF / print output. */
export const formatOnsetDurationForPdf = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw || raw === "-") return raw;
  if (raw === "Today" || raw === "Invalid date" || raw === "Same day") {
    return raw;
  }

  const hasAgo = /\sago\s*$/i.test(raw);
  const core = hasAgo ? raw.replace(/\sago\s*$/i, "").trim() : raw;
  const parsed = parseCombinedDuration(core);

  if (parsed.value) {
    const formatted = formatCombinedDurationForDisplay(
      `${parsed.value} ${parsed.unit}`
    );
    return hasAgo ? `${formatted} AGO` : formatted;
  }

  return raw
    .replace(TIME_UNIT_PATTERN, (match) => match.toUpperCase())
    .replace(/\bago\b/gi, "AGO");
};
